import api from '../..'

export const destroyLikertQuestion = (questionId: number) => {
  return api.delete(`administration/questions/likerts/${questionId}`)
}
export const destroyOpenEndedQuestion = (questionId: number) => {
  return api.delete(`administration/questions/open_endeds/${questionId}`)
}
